import { Component, Output, EventEmitter } from '@angular/core';
import { FormControl, UntypedFormGroup } from '@angular/forms';
import { AuthService } from '../../shared/auth.service';
import { ToastrService } from 'ngx-toastr';
import { LocalStorageService } from '../../shared/local-storage.service';
import { Router } from '@angular/router';
import { OnlineStatusService, OnlineStatusType } from 'ngx-online-status';
import { ConvertHMSToLogbook, ConvertToLogbook } from '../../shared/submission-data.model';

/**
 * The help form. Collects some information and sends it to the server with current unsubmitted logbook data.
 */
@Component({
    selector: 'app-help-form',
    templateUrl: './help-form.component.html',
    styleUrls: ['./help-form.component.css'],
    standalone: false
})
export class HelpFormComponent {

  // back to help screen
  @Output() backToHelp: EventEmitter<any> = new EventEmitter<any>();

  // yes or no
  fromProblemDevice: UntypedFormGroup = new UntypedFormGroup({
    fromProblemDevice: new FormControl<string>("Yes")
  });

  // select all problems that apply
  problemAreas: UntypedFormGroup = new UntypedFormGroup({
    problemAreas: new FormControl<any[]>([])
  });

  // additional comments
  comment: UntypedFormGroup = new UntypedFormGroup({
    comment: new FormControl<string>("")
  });

  sending: boolean = false;

  constructor(
    public dataSync: LocalStorageService,
    public router: Router,
    private auth: AuthService,
    private toastr: ToastrService,
    private onlineStatusService: OnlineStatusService) {

  }


  /**
   * After successfully submitting the help form, go back to help screen
   */ 
  afterSubmitHelpForm(helpJson: any): void {
    this.auth.postHelpForm(helpJson).subscribe((res: any) => {
      this.sending = false;
      console.log(res);
      this.toastr.success('Help form submitted', 'Success');
      this.fromProblemDevice.patchValue({ fromProblemDevice: '' });
      this.problemAreas.patchValue({ problemAreas: [] });
      this.comment.patchValue({ comment: '' });
      this.backToHelp.emit();
    }, (err: any) => {
      this.toastr.error('Could not submit', 'Error');
      this.sending = false;
      console.log(err);
    });
  }

  /**
   * Help form submission upon "Submit" button clicked
   */ 
  submitHelpForm() {

    let helpJson: any = {
      "formData": {
        "fromProblemDevice": this.fromProblemDevice.value.fromProblemDevice,
        "problemAreas": this.problemAreas.value.problemAreas,
        "comment": this.comment.value.comment
      },
      "unsubmittedLogData": []
    };    
    let trip = this.dataSync.user_trip();
    if (trip.sets.find(set => set.fishery == 'Groundfish')) helpJson.unsubmittedLogData.push(ConvertToLogbook(this.dataSync, trip.groundfishDelivery));
    if (trip.sets.find(set => set.fishery == 'HMS')) helpJson.unsubmittedLogData.push(ConvertHMSToLogbook(this.dataSync, trip.hmsDelivery));

    // user is online
    if (this.onlineStatusService.getStatus() == OnlineStatusType.ONLINE) {
      this.sending = true;

      // user access token has expired
      if (this.auth.checkAccessToken().expired) {
        console.log("Access token expired, refreshing..");

        // authentication timeout, back to menu
        if (this.auth.checkRefreshToken().expired) {
          this.toastr.warning('Login to submit your help form', 'Sign-up session expired');
          this.router.navigate(['menu']);
        }

        // no timeout, submit form
        else {
          this.auth.postRefreshToken().subscribe((token: any) => {
            let user = this.dataSync.current_user();
            user.accessToken = token.accessToken;
            user.refreshToken = token.refreshToken;
            this.dataSync.current_user.set(user);
            this.dataSync.updateUser(false, true).then(() => this.afterSubmitHelpForm(helpJson));
          });
        }
      }

      // access token not expired
      else {
        this.afterSubmitHelpForm(helpJson);
      }
    }

    else {
      this.toastr.warning('Internet connection required to submit help request', 'No Connection');
    }
  }

}
